import React, { useContext } from "react";
import { Button, Text, Box } from "grommet";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Logout } from "grommet-icons";
import API_URL from "../config/config";

const LogoutButton = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    window.location.href = `${API_URL}/auth/logout`;
    // Navigate to login page after logout
  };

  return (
    <Box pad="small" justify="end" direction="row" onClick={handleLogout}>
      <Logout color="brand" size="large" margin={{ top: "medium" }} />
      <Text size="small" color="brand">
        Logout
      </Text>
    </Box>
  );
};

export default LogoutButton;
